import { render, staticRenderFns } from "./OrderControl.vue?vue&type=template&id=648809cd&lang=html&"
import script from "./OrderControl.vue?vue&type=script&lang=js&"
export * from "./OrderControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports